const triggerVerifyUser = (country ,lang, sessionId ,externalRefId,email) => {
   let CustomerResponse = {};
    const verifyUserHeaders = {
         "Content-Type": `application/json`,
          "x-wu-correlationId": `web-` + generateUniqueID(),
          "x-wu-externalRefId": externalRefId,
          "WuCountryCode": country,
          "WuLanguageCode": lang,
          "x-wu-sessionId": sessionId,
          "x-wu-operationName": "verifyUser",
          "Accept-Language": `${lang}-${country}`,
          "WuCountryCode": country,
          "WuLanguageCode": lang,
          "x-wu-sessionId": sessionId,
          "accept": `application/json`,
          "isrrenabled":false
      };

    const customerDetail = {
        "customer": {
            "email": email
        },
        "registrationType": "EMAIL"
    }

    const requestOptions = {
        method: "POST",
        body: JSON.stringify(customerDetail),
        headers: verifyUserHeaders
    };

    try {
        return fetchApiWu('/auth/v2/verify/user', requestOptions, 'verifyUser')
            .then((customer) => {
                if(customer.status){
                    CustomerResponse.statusCode = "200"
                    CustomerResponse.status = customer.status
                    CustomerResponse.registered = false
                    CustomerResponse.message = customer.message
                    return CustomerResponse
                }
                else if (customer.error.errorCode)
                {
                    CustomerResponse.errorCode = customer.error.errorCode;
                    CustomerResponse.errorMessage = customer.error.errorMessage;
                    return CustomerResponse;
                }
                else{
                    CustomerResponse.errorCode = customer.name;
                    CustomerResponse.errorMessage = customer.message;
                    return CustomerResponse;
                }  
                
            })
    } catch(e) {
        console.log(e);
        return "error"
        
    }
    
};

window.queryData.triggerVerifyUser = triggerVerifyUser;